export const chartTypes = {
    LineChart: 'LineChart',
    ColumnChart: 'ColumnChart',
    AreaChart: 'AreaChart',
    ComboChart: 'ComboChart'
};

export default chartTypes;
